var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 23.8333C13.1665 20.8878 15.5543 18.5 18.4998 18.5H46.4998C49.4454 18.5 51.8332 20.8878 51.8332 23.8333V46.5C51.8332 49.4455 49.4454 51.8333 46.4998 51.8333H18.4998C15.5543 51.8333 13.1665 49.4455 13.1665 46.5V23.8333Z",
    stroke: "#676879",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8335 13.1667V22.5",
    stroke: "#676879",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1665 13.1667V22.5",
    stroke: "#676879",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 29.1667H43.8332",
    stroke: "#103045",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 49,
    r: 13.5,
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.875 60.375L55.25 54.75M39.125 48C39.125 42.8223 43.3223 38.625 48.5 38.625C53.6777 38.625 57.875 42.8223 57.875 48C57.875 53.1777 53.6777 57.375 48.5 57.375C43.3223 57.375 39.125 53.1777 39.125 48Z",
    stroke: "#103045",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlank);
export default __webpack_public_path__ + "static/media/calendar_blank.84b6a5af7737fced6e40f024225039e3.svg";
export { ForwardRef as ReactComponent };